import React, { Component } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as util from './commons';
import { Col, Form, Row } from 'react-bootstrap';


export default class GeneralDialogFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        return (
            <>
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={this.props.onCancelClick} iconPos="right" />
                </Col>
                {
                    this.props.hideOk === true?
                    <></>
                    :
                <Col style={{textAlign:"left"}}>
                    <Button label="تائید" icon="pi pi-check" onClick={this.props.onOkClick} loading={this.props.saving} iconPos="right" severity="success" />
                </Col>                                       
                }
            </Row>
            </>
        )
    }
}